import React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

const StatCard = ({ label, value, icon: Icon, hint }) => (
  <div className="flex flex-col h-full p-5 transition-all border bg-card border-border rounded-xl animate-fade-up hover:border-primary/40 hover:shadow-sm">
    <div className="flex items-start justify-between gap-3">
      <div className="min-h-[2.25rem] text-[11px] uppercase tracking-[0.18em] leading-snug text-muted-foreground font-semibold">
        {label}
      </div>
      {Icon && (
        <div className="grid rounded-lg w-9 h-9 shrink-0 place-items-center bg-primary/10 text-primary">
          <Icon className="w-4 h-4" />
        </div>
      )}
    </div>
    <div className="mt-1 text-3xl font-bold tracking-tight truncate font-display tabular-nums">{value}</div>
    {hint && (
      <div className="flex justify-end pt-3 mt-auto">
        <TooltipProvider delayDuration={150}>
          <Tooltip>
            <TooltipTrigger asChild>
              <span
                role="button"
                tabIndex={0}
                aria-label={`About ${label}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                className="inline-flex transition-colors shrink-0 cursor-help text-muted-foreground/40 hover:text-foreground"
              >
                <Info className="w-3.5 h-3.5" />
              </span>
            </TooltipTrigger>
            <TooltipContent side="top" align="end" className="max-w-[220px] text-xs">
              {hint}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    )}
  </div>
);

export default StatCard;
